import React from "react";
import { IonGrid, IonRow, IonCol, isPlatform, IonLabel } from "@ionic/react";
import "./RateHeader.scss";
import i18n from "i18n";

export default ({length}: any) => {
  const isMobile = isPlatform("mobile");
  return (
    <IonGrid className="pay-header-component" data-test={"pay-header"}>
      <IonRow>
        <IonCol data-testid="charge-description" size={isMobile ? "4" : "4.4"}>
          <IonLabel className={"charge-description header"}>Charge </IonLabel> <br/> <IonLabel className={"charge-description header"}> Description</IonLabel>
        </IonCol>
        <IonCol data-testid="rate-qualifier" className={"header"} size={isMobile ? "3.5" : (length>4)?"3.8":"4.0"}>
         {i18n.t("Rate Qualifier")}
        </IonCol>
        <IonCol data-testid="qty" className={"header"} size={isMobile ? "1.5" : "1.0"}>
          {i18n.t("Qty")}
        </IonCol>
        <IonCol data-testid="total" className={"header header-total"} size={isMobile ? "3" : (length>4)?"2.2":"1.8"}>
          {i18n.t("Total")}
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};
